(function () {
    'use strict';

    /*
     * Send Package Controller
     */

    angular.module('ShargoApp')

    .constant('vehiclesCfg', {
        "0": "bike",
        "1": "moto",
        "2": "car",
        "3": "van"
    })

    .service('NotificationsService',function ($http, Configuration) {
        var svc = {};

        svc.putNotificationToken = function (token, os, lan) {
            var params = {
                deviceToken: token,
                deviceOS: os,
                deviceLanguage: lan
            };
            $http.put(Configuration.apiUrl + '/installations', params, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            });
        };

        return svc;
    })

    .service('DeliversService', function($http, $q, Configuration) {

        var svc = {};

		svc.getPriceCancelDelivery = function (deliveryId) {
		    return svc.getCancellationFee(deliveryId, null);
		};

		svc.getPriceCancelDestination = function (deliveryId, destinationId) {
			return svc.getCancellationFee(deliveryId, destinationId);
		};

		svc.getCancellationFee = function(deliveryId, destinationId) {
            var deferResponse = $q.defer();
            var dynamicPath = "/senders/delivers/getCancellationFee/" + deliveryId;
            if(destinationId) {
                dynamicPath += "/destination/" + destinationId;
            }
            $http.get(Configuration.apiUrl + dynamicPath, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function getCancelPriceCbkOK(res) {
                if(res.data && (res.data.fee || res.data.fee === 0)) {
                    deferResponse.resolve(res.data.fee);
                } else {
                    deferResponse.reject("---");
                }
            }, function getCancelPriceCbkKO(err) {
                deferResponse.reject(err);
            });
            return deferResponse.promise;
        };

		svc.cancelDelivery = function (id) {
			var params = {
				deliverId: id
			};
			return $http.post(Configuration.apiUrl + "/senders/delivers/cancelDelivery", params, {
				headers: {
					'x-token': localStorage.getItem('xtoken'),
					'x-userid': localStorage.getItem('userid')
				}
			});
		};

		svc.cancelDestination = function (id, destination) {
			var params = {
				deliverId: id,
                destinationId: destination
			};
			return $http.post(Configuration.apiUrl + "/senders/delivers/cancelDestination", params, {
				headers: {
					'x-token': localStorage.getItem('xtoken'),
					'x-userid': localStorage.getItem('userid')
				}
			});
		};

        svc.getInvoices = function() {
            return $http.get( Configuration.apiUrl + "/senders/invoices" ,{
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            });
        };

        svc.downloadInvoice = function(invoice) {
            console.log("downloadInvoice! ", invoice);
            var id = invoice._id;
            var supportsDownloadAttribute = 'download' in document.createElement('a');
            var invoiceName = 'Factura-M' + invoice.month + '-' + invoice.year + '.pdf';
            var win;

            if(!supportsDownloadAttribute) {
                win = $window.open('about:blank', invoiceName);
            }
            console.log('Redirecting to', invoice.url)
            $window.open(invoice.url, "_blank");

        };

        svc.downloadLabels = function(date) {
            return $http.get( Configuration.apiUrl + "/v1/labels/" + date, {
                responseType: 'arraybuffer',
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            });
        };

        svc.getDeliversPage = function (pageNum) {
            console.log("GET DELIVERS PAGE " + pageNum);
            var deferDlvrs = $q.defer();
            $http.get(Configuration.apiUrl + '/senders/delivers/history/paginate?pageNumber=' + pageNum, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function (response) {
                var data = response.data;
                //var resBundle = _.pick(response.data, ['pageNumber', 'totalPages']);
                var resBundle = {
                    pageNumber: response.data.pageNumber,
                    totalPages: response.data.totalPages
                };
                ['activeDelivers', 'historyDelivers', 'scheduledDelivers'].forEach(function(dKey) {
                    resBundle[dKey] = svc.initializeDelivers(data[dKey]);
                });
                deferDlvrs.resolve(resBundle);
            }, function (errorRes) {
                console.log("Error getting deliveries pagination -> ", errorRes);
                deferDlvrs.reject(errorRes && errorRes.data ? errorRes.data.message : '');
            });
            return deferDlvrs.promise;
        };

        svc.getHourText = function (theDate) {
            var dateTxt = "";
            if(theDate) {
                dateTxt = theDate.getHours() + ":" + ("0" + theDate.getMinutes()).slice(-2);
            }
            return dateTxt;
        };

        svc.initializeDelivers = function (arrayDlvrs) {
            if(arrayDlvrs !== null && arrayDlvrs.length > 0) {
                arrayDlvrs.forEach(function(rawDlvr) {
                    rawDlvr = svc.formatSelectedDeliver(rawDlvr);
                });
            }
            return arrayDlvrs;
        };

        svc.getDeliverDetail = function(id) {
            var deferDlvrDtail = $q.defer();
            $http.get(Configuration.apiUrl + '/delivers?type=sender&deliverId=' + id, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function successCallback(response) {
                console.log("DELIVER DETAIL", response.data);
                deferDlvrDtail.resolve(svc.formatSelectedDeliver(response.data));
            }, function(errorRes) {
                console.log("svc getDeliverDetail err: ", errorRes);
                var errMsg = (errorRes.data && errorRes.data.message) ? errorRes.data.message : 'Error';
                deferDlvrDtail.reject(errMsg);
            });
            return deferDlvrDtail.promise;
        };

        svc.getThinInfo = function(id) {
            var deferDlvrThin = $q.defer();
            $http.get(Configuration.apiUrl + '/delivers/thin?deliverId=' + id, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function successCallback(response) {
                deferDlvrThin.resolve(response.data);
            }, function(errorRes) {
                var errMsg = (errorRes.data && errorRes.data.message) ? errorRes.data.message : 'Error';
                deferDlvrThin.reject(errMsg);
            });
            return deferDlvrThin.promise;
        };

        svc.getTrackingCode = function(shortid) {
            var deferReq = $q.defer();
            $http.get(Configuration.apiUrl + '/delivers/tracking/shortid?shortid=' + shortid, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function successCallback(response) {
                deferReq.resolve(response.data);
            }, function(errorRes) {
                deferReq.reject(errorRes.data.message);
            });
            return deferReq.promise;
        };

        svc.getInfoFromTrackingCode = function(trackingCode) {
            var deferResponse = $q.defer();
            $http.get(Configuration.apiUrl + '/delivers/tracking?id=' + trackingCode, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function successCallback(response) {
                console.log(response);
                deferResponse.resolve(response.data);
            }, function(errorRes) {
                var errMsg = (errorRes.data && errorRes.data.message) ? errorRes.data.message : 'Error';
                deferResponse.reject(errMsg);
            });
            return deferResponse.promise;
        };

        svc.formatSelectedDeliver = function (rawDlvr) {
            var formattedDlvr = rawDlvr;
            if (formattedDlvr.orderDate) {
                formattedDlvr.orderDate = new Date(formattedDlvr.orderDate);
                formattedDlvr.hourText = "Recoger a las " + svc.getHourText(formattedDlvr.orderDate);
            } else {
                formattedDlvr.hourText = "Recoger lo antes posible";
            }
            if (formattedDlvr.transport === 0) formattedDlvr.transText = "Bicicleta";
            else if (formattedDlvr.transport == 1) formattedDlvr.transText = "Moto";
            else if (formattedDlvr.transport == 2) formattedDlvr.transText = "Coche";
            else formattedDlvr.transText = "Furgoneta";
            var filteredDestinations = [];
            var hasAnyCancel = (formattedDlvr.status == "canceled" || formattedDlvr.status == "returned");
            var hasAllCanceled = true;
            formattedDlvr.destinations.forEach(function(d) {
                if(d.status != 3) {
                    filteredDestinations.push(d);
                }
                if(d.status == 2 || d.status == 3) {
                    hasAnyCancel = true;
                }
                if(d.status == 0 || d.status == 1) {
                    hasAllCanceled = false;
                }
            });
            formattedDlvr.hasAnyCancel = hasAnyCancel;
            formattedDlvr.hasAllCanceled = hasAllCanceled;
            formattedDlvr.destinations = filteredDestinations;
            return formattedDlvr;
        };

        svc.cancel = function(id) {
            var deferCancel = $q.defer();
            $http({
                method: 'delete',
                url: Configuration.apiUrl + '/delivers?deliverId=' + id,
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function(cancelRes) {
                deferCancel.resolve("cancel ok");
            }, function(cancelErr) {
                deferCancel.reject(cancelErr);
            });
            return deferCancel.promise;
        };

        svc.sendRating = function(newRating, destinationId) {
            var params = {
                driverRating: newRating,
                destinationId: destinationId
            };
            return $http.post(Configuration.apiUrl + '/delivers/destination/rating', params);
        };

        svc.sendDeliverRating = function(newRating, deliverId) {
            var params = {
                deliverId: deliverId,
                driverRating: newRating
            };
            return $http.post(Configuration.apiUrl + '/delivers/rating', params, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            });
        };

        svc.shouldRate = function() {
            return $http.get(Configuration.apiUrl + '/senders/shouldRate', {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            });
        };

        return svc;
    })

    .filter('vehicleName', function(vehiclesCfg) {
        return function(input) {
            return (input !== undefined && input !== "") ? vehiclesCfg[input] : "";
        };
    })

    .filter('activeDate', function($filter) {
        function areTheSameDay(date1, date2) {
            return (date1.getDate() == date2.getDate() && date1.getMonth() == date2.getMonth() && date1.getFullYear() == date2.getFullYear());
        }
        return function(inputDate) {
            var outputDate = "";
            if(inputDate) {
                var today = new Date();
                if(areTheSameDay(today, inputDate)) {
                    outputDate = $filter('formatDate')(inputDate, 'hour');
                } else {
                    outputDate = $filter('formatDate')(inputDate);
                }
            }
            return outputDate;
        };
    })

    .filter('formatDate', function() {
        function addZero(num) {
            return ("0" + num).slice(-2);
        }
        return function(inputDate, opts) {
            var output = '';
            if (typeof inputDate == "string") {
                inputDate = new Date(inputDate);
            }
            if(inputDate) {
                var separator = '/';
                if(!opts || opts == 'date') {
                    output = addZero(inputDate.getDate()) + separator +  addZero(inputDate.getMonth() + 1) + separator + inputDate.getFullYear();
                }
                if(!opts || opts == 'hour') {
                    if(output && output !== '') {
                        output += ' · ';
                    }
                    output += addZero(inputDate.getHours()) + ':' + addZero(inputDate.getMinutes()) + 'h';
                }
            }
            return output;
        };
    })

    .filter('statusName', function() {
        return function(input) {
            var output = "";
            switch(input) {
                case 'created':
                case 'pending_driver_acceptance':
                case 'reading_delivery':
                case 'no_found':
                case 'cargo':
                    output = "status.searching";
                    break;
                case 'assigned':
                    output = "status.picking";
                    break;
                case 'waiting_pickup':
                    output = "status.picking";
                    break;
                case 'in_route':
                    output = "status.delivering";
                    break;
                case 'delivered':
                case 'delivered_with_errors':
                    output =  "status.delivered";
                    break;
                case 'canceled':
                    output =  "status.canceled";
                    break;
                case 'returned':
                    output =  "status.returned";
                    break;
            }
            return output;
        };
    })

    .controller('DashboardController', function ($scope, $rootScope, $window, $mdSidenav, $http, $location, $timeout, $interval, $q, $anchorScroll,  Configuration, DeliversService, NotificationsService, deviceDetector) {
		$rootScope.pageConfiguration = {
			footer: true,
			header: {
				solid: -1000,
				background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
				preheader: false,
				headerLink: $rootScope.url('home'),
				headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
				logIn: true,
				dashboard: true,
				callToAction: {
					link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
					text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
					target: '',
					hide: false,
					disabled: false
				},
				profile: true
			}
		};

		if ($rootScope.mgm.invitate){
            $rootScope.mgm.show.promotion = "invitation";
            $rootScope.blur.MGMPopUppromotion = true;
        }

        var oldCurrentDelivery;
        $scope.isLoading = true;
        $scope.showRatingForm = false;
        $scope.activeDelivers = [];
        $scope.historyDelivers = [];
        $scope.scheduledDelivers = [];
        $scope.selectedList = [];
        $scope.selectedDeliver = 0;
        $scope.selectedType = 0;
        $scope.delLat = "";
        $scope.delLong = "";
        $scope.pickLat = "";
        $scope.pickLong = "";
        $scope.markers = {};
        $scope.formErrorText = [];
        $scope.user = {};
        $scope.currentPage = 1;
        $scope.cancellableStates = ['created', 'pending_driver_acceptance', 'reading_delivery', 'no_found', 'cargo', 'assigned', 'scheduled'];
		$scope.cancellableDestinationStates = ['in_route'];
        $scope.initialPage = 1;

        function showSidebar() {
            if(!$mdSidenav('sidebar-left').isOpen()) {
                $timeout(function() {
                    $scope.snLocked = true;
                }, 2000);
            }
        }

        /* User Variables */

        $http.get(Configuration.apiUrl + '/senders/me', {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            }).then(function (response) {
                $scope.user.firstName = response.data.firstName;
                $scope.user.lastName = response.data.lastName;
                $scope.user.email = response.data.email;
                $scope.user.phone = response.data.phone;
                $scope.user.city = response.data.city;
                $scope.isUserLogged = true;

                $rootScope.user.firstName = response.data.firstName;
                $rootScope.user.lastName = response.data.lastName;
                $rootScope.user.email = response.data.email;
                $rootScope.user.phone = response.data.phone;
                $rootScope.user.imageUrl = response.data.imageUrl;
                $rootScope.user.referralUrl = response.data.referralUrl;
                $rootScope.user.popup = response.data.popup;
                $rootScope.isUserLogged = true;
                if (response.data.referralUrl){
					$rootScope.clipboardTextButton = response.data.referralUrl.substr(response.data.referralUrl.indexOf("shargo.io"));
                }
			    if(response.data.popup.mgmCompletedGuest){
                    $rootScope.mgm.show.promotion = "refered"; //"refered" "invitation"
                    $rootScope.blur.MGMPopUppromotion = true;
                }
                else if(response.data.popup.mgmCompletedHost.length > 0){
                    $rootScope.mgm.list = response.data.popup.mgmCompletedHost;
                    $rootScope.mgm.index = 0;
                    $rootScope.mgm.show.promotion = "referral"; //"refered" "invitation"
                    $rootScope.blur.MGMPopUppromotion = true;
                }
            }, function (data) {
                $scope.isUserLogged = false;
            });

        function removeMarker(type) {
            if($scope.markers && $scope.markers[type]) {
                $scope.directionsDisplay.setMap(null);
                $scope.markers[type].setMap(null);
                delete $scope.markers[type];
            }
        }

        function cleanOldStatus(status) {
            switch(status) {
                case 'assigned':
                    for (var i = 0; i < $scope.selectedDeliver.destinations.length; i++) {
                        removeMarker('delivery'+i);
                    }
                    break;
                case 'in_route':
                    removeMarker('pickup');
                    break;
                case 'delivered':
                case 'delivered_with_errors':
                    removeMarker('driver');
                    break;
            }
        }

        $scope.rateConfirmationEnabled = false;
        $scope.ratingDone = false;
        $scope.ratingBundle = {
            score: 0,
            readOnly: false,
            reseteable: false
        };
        $scope.enableRateConfirmation = function() {
            if($scope.ratingBundle && $scope.ratingBundle.score > 0) {
                $scope.rateConfirmationEnabled = true;
            }
        };
        $scope.sendRating = function(newRating, deliverId) {
            $scope.rateConfirmationEnabled = false;
            DeliversService.sendDeliverRating(newRating, deliverId).then(function successCallback(response) {
                $scope.ratingDone = true;
                $scope.ratingBundle.readOnly = true;
                $scope.selectedDeliver.shouldRate = false;
                $timeout(function () { $scope.showRatingForm = false; }, 1700);
            }, function errorCallback(err) {
                console.log("ERROR ON SEND RATING", err);
            });
        };
        $scope.evaluateDriver = function () {
            $scope.showRatingForm = true;
            $scope.ratingDone = false;
            $scope.rateConfirmationEnabled = false;
            $scope.ratingBundle = {
                score: 0,
                readOnly: false,
                reseteable: false
            };
        };

        $scope.selectPage = function(newPage, toTop, isInterval, goLast) {
            if(toTop) {
                $anchorScroll();
            }
            $scope.formErrorText = [];
            DeliversService.getDeliversPage(newPage).then(function (data) {
                $scope.totalPages = data.totalPages;
                if(newPage > $scope.totalPages) {
                    $scope.selectedDeliver = undefined;
                    $scope.currentPage = 1;
                } else {
                    $scope.currentPage = newPage;
                }
                $scope.activeDelivers = data.activeDelivers;
                $scope.scheduledDelivers = data.scheduledDelivers;
                $scope.historyDelivers = data.historyDelivers;

                //TODO: change this for a directive/component
                $scope.firstRate = false;
                if ($scope.currentPage === 1 && !isInterval) {
                    waitUntilPageLoaded().then(function () {
                        setPositionRatingBox();
                    });
                }
                var window = angular.element($window);
                window.bind('resize', function () {
                    waitUntilPageLoaded().then(function () {
                        setPositionRatingBox();
                    });
                });

                function setPositionRatingBox() {
                    for (var i = 0; i < $scope.historyDelivers.length && !$scope.firstRate; ++i) {
                        if ($scope.historyDelivers[i].shouldRate) {
                            var element = angular.element(".dashboard .history-delivers .deliver")[i];
                            angular.element(".dashboard .rating-box").css({
                                "top": element.offsetTop + (element.offsetHeight - 30)/2 + "px",
                                "left": element.offsetLeft + element.offsetWidth + 5 + "px"
                            });
                            $scope.firstRate = $scope.historyDelivers[i]._id;
                        }
                    }
                }

                function waitUntilPageLoaded() {
                    var deferred = $q.defer();
                    var checkExist = setInterval(function() {
                        if ($scope.pageKey.name === "dashboard" && $scope.currentPage === 1) {
                            for (var i = 0; i < $scope.historyDelivers.length && !$scope.firstRate; ++i) {
                                var histDelivers = angular.element(".dashboard .history-delivers .deliver");
                                if ($scope.historyDelivers[i].shouldRate && histDelivers) {
                                    if (histDelivers[i] && histDelivers[i].offsetLeft > 0) {
                                        clearInterval(checkExist);
                                        deferred.resolve("Page loaded");
                                    }
                                }
                            }
                        }
                        else {
                            clearInterval(checkExist);
                            deferred.reject();
                        }
                    }, 100);
                    return deferred.promise;
                }

                // get detail only if it's necessary
                if($scope.selectedDeliver) {
                    DeliversService.getThinInfo($scope.selectedDeliver._id).then(function(delInfo) {
                        // {"status": "delivered", "lat": 34.02934968189999, "lon": -118.2728332466827 }
                        if( deliveryStatusChanged(delInfo, oldCurrentDelivery) ) {
                            cleanOldStatus(delInfo.status);
                            getDeliverDetail($scope.selectedDeliver._id);
                        } else if( deliveryCoordsChanged(delInfo, oldCurrentDelivery) ) {
                            // updatear coords del driver
                            $scope.selectedDeliver.driver.currentLocation.coordinates[0] = delInfo.lon;
                            $scope.selectedDeliver.driver.currentLocation.coordinates[1] = delInfo.lat;
                            $scope.updatePackageMap();
                        }
                        oldCurrentDelivery = delInfo;
                        showSidebar();
                    }, function(err) {
                        console.log("DeliversService.getThinInfo > err: ", err);
                        $scope.changePage(1);
                        //$scope.selectPage($scope.currentPage);
                        /*
                        var firstId = getFirstIDFromCurrentPage();
                        if(firstId) {
                            getDeliverDetail(firstId);
                        }
                        */
                    });
                } else {
                    var delId = getFirstIDFromCurrentPage();
                    if(delId) {
                        getDeliverDetail(delId);
                    }
                    showSidebar();
                }

                $scope.isLoading = false;
                $rootScope.blur.dialogPushNotification = $rootScope.dialogPushNotification;
            }, function errorCallback(errMsg) {
                console.log("ERROR TEST 1");
                $scope.generateError(errMsg);
                if (goLast) {
                    $scope.selectPage($scope.totalPages, toTop);
                }
            });
        };

        $scope.selectPage($scope.currentPage);

        $scope.changePage = function (newPage) {
            if ($scope.initialPage < $scope.totalPages - 4) {
                if (newPage > $scope.initialPage + 2) {
                    $scope.initialPage += 1;
                }
            }
            if ($scope.initialPage > 1){
                if (newPage < $scope.initialPage + 2) {
                    $scope.initialPage -= 1;
                }
            }
            $scope.selectedDeliver = undefined;
            $scope.selectPage(newPage, true);
        };

        function deliveryStatusChanged(newDeli, oldDeli) {
            var itChanged = true;
            if(newDeli && newDeli.statusChanged == 1) {
                return true;
            }
            if(oldDeli && newDeli && oldDeli.status == newDeli.status) {
                itChanged = false;
            }
            return itChanged;
        }

        function deliveryCoordsChanged(newDeli, oldDeli) {
            var itChanged = true;
            if(oldDeli && newDeli && oldDeli.lat && newDeli.lat && oldDeli.lon && newDeli.lon) {
                itChanged = (oldDeli.lat != newDeli.lat || oldDeli.lon != newDeli.lon);
            } else {
                itChanged = false;
            }
            return itChanged;
        }

        var stopUpdate = $interval(function() {
            // selectPage decides if it needs thin or fat request
            $scope.selectPage($scope.currentPage, false, true);
        }, Configuration.updateInterval * 1000);

        $scope.$on("$destroy", function( event ) {
                $interval.cancel( stopUpdate );
                stopUpdate = undefined;
            }
        );

        document.addEventListener('visibilitychange', function() {
            console.log("VISIBILITY CHANGE!");
            if (!angular.isUndefined(stopUpdate)) {
                $interval.cancel(stopUpdate);
                stopUpdate = undefined;
            }
            else {
                stopUpdate = $interval(function() {
                    // selectPage decides if it needs thin or fat request
                    $scope.selectPage($scope.currentPage, false, true);
                }, Configuration.updateInterval * 1000);
            }
        });

        function getFirstIDFromCurrentPage() {
            var firstId;
            if($scope.activeDelivers.length > 0) {
                firstId = $scope.activeDelivers[0]._id;
            } else  if($scope.scheduledDelivers.length > 0) {
                firstId = $scope.scheduledDelivers[0]._id;
            } else  if($scope.historyDelivers.length > 0) {
                firstId = $scope.historyDelivers[0]._id;
            }
            return firstId;
        }

        function resetCurrentPage() {
            $scope.selectedDeliver = undefined;
            $scope.selectPage($scope.currentPage, true, false, true);
        }

        /* Deliver Detail */

        function getDeliverDetail(id) {
            // $scope.isLoading = true;
            $scope.formErrorText = [];
            DeliversService.getDeliverDetail(id).then(function successCallback(deliverDetail) {
                $scope.selectedDeliver = deliverDetail;
				$scope.deliveryMainInfoCont = [];
                for (var i = 0; i < deliverDetail.destinations.length; ++i){
					$scope.deliveryMainInfoCont.push("closed");
                }
				if (!$scope.map) {
                    $timeout(function () {
                        google.maps.event.addDomListener(window, 'load', $scope.generateMap());
                    },1000);
                } else {
                    $scope.updatePackageMap();
                }
                generateOldRecord($scope.selectedDeliver);
               //  $scope.isLoading = false;
            }, function errorCallback(errMsg) {
                console.log("ERROR TEST 2");
                $scope.generateError(errMsg);
            });
        }

        function generateOldRecord(newRecord) {
            oldCurrentDelivery = {
                status: newRecord.status
            };
            if(newRecord && newRecord.driver && newRecord.driver.currentLocation) {
                var driverCoords =  newRecord.driver.currentLocation;
                oldCurrentDelivery.lat = driverCoords.coordinates[1];
                oldCurrentDelivery.lon = driverCoords.coordinates[0];
            }
        }


        $scope.range = function(a, b) {
            var array = [];
            for(var i = a; i <= b; ++i) {
                array.push(i);
            }
            return array;
        };

		$scope.cancelPricePopUp = "";
        $scope.cancelDelivery = function(id, type, destination) {
            $scope.cancelDeliveryId = id;
            $scope.cancelDeliveryDestination = destination;
            $scope.cancelDeliveryType = type;
            $rootScope.blur.dialogCancelDelivery = $scope.dialogCancelDeliveryForced = $scope.dialogCancelDelivery = true;

            if (type == "delivery"){
				DeliversService.getPriceCancelDelivery(id)
                    .then(function (fee) {
                        console.log("THIS IS RESPONSE PRICE CANCEL DELIVERY", fee);
                        $scope.cancelPricePopUp = fee;
					})
                    .catch(function (err) {
                        console.log("GET CANCEL DELIVERY PRICE ERROR", err);
                        $scope.cancelPricePopUp = "---";
					})
            }
            else{
				DeliversService.getPriceCancelDestination(id, destination)
					.then(function (fee) {
						console.log("THIS IS RESPONSE PRICE CANCEL DESTINATION", fee);
						$scope.cancelPricePopUp = fee;
					})
					.catch(function (err) {
						console.log("GET CANCEL DESTINATION PRICE ERROR", err);
                        $scope.cancelPricePopUp = "---";
					})
            }
        };

        $scope.hideCancelDialog = function () {
            $rootScope.blur.dialogCancelDelivery = $scope.dialogCancelDelivery = $scope.dialogCancelDeliveryForced;
            $scope.dialogCancelDeliveryForced = false;
        };

        $scope.hideLabelsDialog = function () {
            console.log("Hide labels dialog");
            $scope.dialogDownloadLabelsForced = false;
            $rootScope.blur.dialogDownloadLabels = $scope.dialogDownloadLabels = $scope.dialogDownloadLabelsForced;
        };

        // INFO: show button if delivery has any valid destination
        $scope.hasAnyCancellableDestination = function(delivery) {
            var isCancellable = false;
            var existNormalDestination = false;
            var destinations = delivery.destinations;
            if(destinations && destinations.length > 0) {
                var i = 0;
                do {
                    var destination = destinations[i];
                    // console.log("hasAnyCancellableDestination > checking status: ",destination.status," delivery.status: ",delivery.status);
                    if(destination.status != 2) { // && $scope.cancellableDestinationStates.indexOf(delivery.status) > -1
                        existNormalDestination = true;
                        isCancellable = true;
                    }
                    i++;
                } while(i < destinations.length && !existNormalDestination);
            }
            // console.log("hasAnyCancellableDestination > isCancellable: ",isCancellable, " delivery: ",delivery);
            return isCancellable;
        };

        $scope.isCancellableDelivery = function(selectedDeliver) {
            return selectedDeliver && selectedDeliver.status && $scope.cancellableStates.indexOf(selectedDeliver.status) > -1
                                            && $scope.hasAnyCancellableDestination(selectedDeliver);
        };

        $scope.confirmCancel = function () {
            console.log("CONFIRM CANCEL");
            if ($scope.cancelDeliveryId) {
                $scope.canceledPressed = true;
                if ($scope.cancelDeliveryType == "delivery"){
                    DeliversService.cancelDelivery($scope.cancelDeliveryId)
                        .then(function (response) {
                            $rootScope.blur.dialogCancelDelivery = $scope.dialogCancelDelivery = $scope.dialogCancelDeliveryForced = false;
                            cleanOldStatus($scope.selectedDeliver.status);
                            getDeliverDetail($scope.selectedDeliver._id);
                            $scope.selectPage($scope.currentPage, false, true);
                            showSidebar();
						})
                        .catch(function (data) {
                            console.log("ERROR CANCEL DELIVERY", data);
						}).finally(function() {
                            $scope.canceledPressed = false;
                        });
                }  else {
                    DeliversService.cancelDestination($scope.cancelDeliveryId, $scope.cancelDeliveryDestination)
                        .then(function (response) {
							//$scope.selectPage($scope.currentPage, false, true);
                            $rootScope.blur.dialogCancelDelivery = $scope.dialogCancelDelivery = $scope.dialogCancelDeliveryForced = false;
                            cleanOldStatus($scope.selectedDeliver.status);
                            getDeliverDetail($scope.selectedDeliver._id);
                            $scope.selectPage($scope.currentPage, false, true);
                            showSidebar();
						})
                        .catch(function (data) {
                            console.log("ERROR CANCEL DESTINATION", data);
						}).finally(function() {
                            $scope.canceledPressed = false;
                        });
                }
                /*
                DeliversService.cancel($scope.cancelDeliveryId)
                .then(function () {
                    $scope.hideCancelDialog();
                    resetCurrentPage();
                }).catch(function (error) {
                    console.log("CANCEL DELIVERY ERROR");
                    console.log(error);
                });
                */
            }
            else {
                console.log("ERROR CANCEL DELIVERY - NO ID");
            }
        };


        $scope.activePushNotifications = function () {
            OneSignal.push(function () {
                OneSignal.registerForPushNotifications();
            });
            $timeout(function () {
                OneSignal.push(["setSubscription", true]);

                OneSignal.push(["getRegistrationId", function(registrationId) {
                    NotificationsService.putNotificationToken(registrationId, deviceDetector.browser, $rootScope.lang);
                }]);

                OneSignal.push(function() {
                    OneSignal.sendTags({
                        user: 'Sender',
                        city: $scope.user.city,
                        email: $scope.user.email,
                        hasSend: '1'
                    });
                });
            },1000);

            $rootScope.blur.dialogPushNotification = $rootScope.dialogPushNotification = false;
        };

        $scope.hidePushNotificationDialog =  function () {
            if($rootScope.dialogPushNotification) {
                $rootScope.blur.dialogPushNotification = $rootScope.dialogPushNotification = false;
            }
        };

        /* Map */

        $scope.generateMap = function () {
            if (window.google) {
                $scope.geocoder = new google.maps.Geocoder();
                $scope.directionsService = new google.maps.DirectionsService();
                $scope.directionsDisplay = new google.maps.DirectionsRenderer({
                    polylineOptions: {
                        strokeColor: "#4a4a4a",
                        strokeWeight: 4
                    }
                });
                var latlng = new google.maps.LatLng($scope.selectedDeliver.pickupLocation.coordinates[1], $scope.selectedDeliver.pickupLocation.coordinates[0]);
                var mapOptions = {
                    zoom: 13,
                    maxZoom: 18,
                    minZoom: 10,
                    center: latlng,
                    navigationControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    draggable: true
                };
                $scope.map = new google.maps.Map(document.getElementById("map"), mapOptions);
                google.maps.event.addListenerOnce($scope.map, 'idle', function () {
                    $scope.updatePackageMap();
                });
            } else {
                console.log("ERROR TEST 4");
                $scope.generateError("No se ha podido cargar Google Maps");
            }
        };

        function geocodePromise(request) {
            var deferredGeocode = $q.defer();
            $scope.geocoder.geocode(request, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    deferredGeocode.resolve(results);
                } else {
                    deferredGeocode.reject(status);
                }
            });
            return deferredGeocode.promise;
        }

        function resetMarkers() {
            console.log("resetMarkers");
            $scope.showRatingForm = false;
            if($scope.markers) {
                $scope.directionsDisplay.setMap(null);
                for (var member in $scope.markers) {
                    if($scope.markers[member]) {
                        $scope.markers[member].setMap(null);
                        delete $scope.markers[member];
                    }
                }
            }
        }

        function getPickUpAndDeliveryMarkupCfgCanceled() {
            console.log("PRINT MAP CANCELED");
			var markers = [];

			markers.push({
				coordinates: $scope.selectedDeliver.pickupLocation.coordinates,
				key: "pickup",
				icon: {url: "./img/svg/pick-up-r.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
				zIndex: 50,
				msg: "No se ha podido localizar la dirección de recogida en el mapa"
			});

			for (var i = 0; i < $scope.selectedDeliver.destinations.length; i++) {
				if ($scope.selectedDeliver.destinations[i].status != 3){
                    if ($scope.selectedDeliver.destinations[i].status == 2){
                        markers.push({
                            coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
                            key: "delivery"+i,
                            icon: {url: "./img/svg/drop-off-r.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                            zIndex: 50,
                            msg: "No se ha podido localizar la dirección de entrega en el mapa"
                        });
                    }
                    else{
                        markers.push({
                            coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
                            key: "delivery"+i,
                            icon: {url: "./img/svg/map-placemark-black.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                            zIndex: 50,
                            msg: "No se ha podido localizar la dirección de entrega en el mapa"
                        });
                    }
				}
			}

			return markers;
		}

        function getPickUpAndDeliveryMarkupCfg() {
			console.log("PRINT MAP NOOOO CANCELED");
			var markers = [];

            markers.push({
                coordinates: $scope.selectedDeliver.pickupLocation.coordinates,
                key: "pickup",
                icon: {url: "./img/svg/map-delivery-black.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                zIndex: 50,
                msg: "No se ha podido localizar la dirección de recogida en el mapa"
            });

            for (var i = 0; i < $scope.selectedDeliver.destinations.length; i++) {
                if ($scope.selectedDeliver.destinations[i].status != 3){
                    if ($scope.selectedDeliver.destinations[i].status == 2){
						markers.push({
							coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
							key: "delivery"+i,
							icon: {url: "./img/svg/drop-off-r.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
							zIndex: 50,
							msg: "No se ha podido localizar la dirección de entrega en el mapa"
						});
                    }
                    else{
						markers.push({
							coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
							key: "delivery"+i,
							icon: {url: "./img/svg/map-placemark-black.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
							zIndex: 50,
							msg: "No se ha podido localizar la dirección de entrega en el mapa"
						});
                    }
                }
            }

            return markers;
        }

        function getDriverAndPickUpMarkupCfg() {
            var markers = [];
            console.log("PRINT MAP getDriverAndPickUpMarkupCfg");
            markers.push({
                coordinates: $scope.selectedDeliver.driver.currentLocation.coordinates,
                key: "driver",
                icon: {url: "./img/svg/map-driver-" + $scope.selectedDeliver.transport + "-yellow.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                zIndex: 100,
                msg: "No se ha podido localizar la dirección del driver en el mapa"
            });

            markers.push({
                coordinates: $scope.selectedDeliver.pickupLocation.coordinates,
                key: "pickup",
                icon: {url: "./img/svg/map-delivery-black.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                zIndex: 50,
                msg: "No se ha podido localizar la dirección de recogida en el mapa"
            });

            for (var i = 0; i < $scope.selectedDeliver.destinations.length; i++) {


                if ($scope.selectedDeliver.destinations[i].status == 2){
                    markers.push({
                        coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
                        key: "delivery"+i,
                        icon: {url: "./img/svg/drop-off-r.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                        zIndex: 50,
                        msg: "No se ha podido localizar la dirección de entrega en el mapa"
                    });
                } else {
                    markers.push({
                        coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
                        key: "delivery"+i,
                        icon: {url: "./img/svg/map-placemark-black.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                        zIndex: 50,
                        msg: "No se ha podido localizar la dirección de entrega en el mapa"
                    });
                }
            }

            return markers;
        }

        function getDriverAndDeliveryMarkupCfg() {
            var markers = [];
            console.log("PRINT MAP getDriverAndDeliveryMarkupCfg");
            markers.push({
                coordinates: $scope.selectedDeliver.driver.currentLocation.coordinates,
                key: "driver",
                icon: {url: "./img/svg/map-driver-" + $scope.selectedDeliver.transport + "-yellow.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                zIndex: 100,
                msg: "No se ha podido localizar la dirección del driver en el mapa"
            });

            for (var i = 0; i < $scope.selectedDeliver.destinations.length; i++) {
                if ($scope.selectedDeliver.destinations[i].status == 2){
                    markers.push({
                        coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
                        key: "delivery"+i,
                        icon: {url: "./img/svg/drop-off-r.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                        zIndex: 50,
                        msg: "No se ha podido localizar la dirección de entrega en el mapa"
                    });
                } else {
                    markers.push({
                        coordinates: $scope.selectedDeliver.destinations[i].dropoffLocation.coordinates,
                        key: "delivery"+i,
                        icon: {url: "./img/svg/map-placemark-black.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
                        zIndex: 50,
                        msg: "No se ha podido localizar la dirección de entrega en el mapa"
                    });
                }
            }

            return markers;
        }

        function getMarkersCfgByStatus(status) {
            var markerCfgsArray = [];
            switch(status) {
                case 'assigned':
                    // en aquest cas la visual ja està feta el que s'haurà de fer és en el mapa posar el pin del driver i només el pickupLocation, i a cada thin actualitzar la posició del driver. D'aquesta manera podrem veure en temps real on està el transportista.
                    markerCfgsArray = getDriverAndPickUpMarkupCfg();
                    break;
                case 'waiting_pickup':
                    // en aquest cas la visual ja està feta el que s'haurà de fer és en el mapa posar el pin del driver i només el pickupLocation, i a cada thin actualitzar la posició del driver. D'aquesta manera podrem veure en temps real on està el transportista.
                    markerCfgsArray = getDriverAndPickUpMarkupCfg();
                    break;
                case 'in_route':
                    // s'ha de fer el mateix que en l'estat assigned però ha d'anar del driver location a la deliveryLocation, ubicació d'entrega.
                    markerCfgsArray = getDriverAndDeliveryMarkupCfg();
                    break;
                case 'delivered':
                case 'delivered_with_errors':
                    // la visual és la mateixa que hi ha ara, no ha de sortir el driver al mapa i només una linea del pickupLocation al deliveryLocation.
                    //break;
                case 'created':
                case 'pending_driver_acceptance':
                case 'reading_delivery':
                case 'no_found':
                case 'cargo':
                case 'scheduled':
                    // la visual és la mateixa i és la que hi ha ara. No tenim driver encara i la crida thin no retorna lat i lon.
                    markerCfgsArray = getPickUpAndDeliveryMarkupCfg();
                    break;
                case 'returned':
				case 'canceled':
                    markerCfgsArray = getPickUpAndDeliveryMarkupCfgCanceled();
                    break;
			}
            return markerCfgsArray;
        }

        function waitUntilMapLoaded() {
            var deferred = $q.defer();
            var checkExist = setInterval(function() {
                if ($scope.pageKey.name === "dashboard"){
                    if (angular.element("#map").length && angular.element("#map")[0] &&
                        angular.element("#map")[0].offsetHeight > 0) {
                            clearInterval(checkExist);
                            deferred.resolve();
                    }
                }
                else {
                    clearInterval(checkExist);
                    deferred.reject();
                }
            }, 100);
            return deferred.promise;
        }

        $scope.updatePackageMap = function () {
            var markerCfgsArray = getMarkersCfgByStatus($scope.selectedDeliver.status);
            console.log("updatePackageMap > updateing packageMap with: ", markerCfgsArray);
            var singleBounds = new google.maps.LatLngBounds();
            waitUntilMapLoaded().then(function (response) {
				markerCfgsArray.map(function(markerCfg) {
					var latLng = {
                        lat: parseFloat(markerCfg.coordinates[1]),
                        lng: parseFloat(markerCfg.coordinates[0])
                    };
                    if (!$scope.markers[markerCfg.key]) {
                        $scope.markers[markerCfg.key] = new google.maps.Marker({
                            map: $scope.map,
                            position: latLng,
                            icon: markerCfg.icon,
                            optimized: false,
                            zIndex: markerCfg.zIndex
                        });
                    } else {
                        $scope.directionsDisplay.setMap(null);
                        $scope.markers[markerCfg.key].setPosition(latLng);
                        $scope.markers[markerCfg.key].icon = markerCfg.icon;
                    }
                    $scope.markers[markerCfg.key].setMap($scope.map);
                    singleBounds.extend(new google.maps.LatLng(latLng.lat, latLng.lng));
                });
                $scope.map.setCenter({
                    lat: parseFloat(markerCfgsArray[0].coordinates[1]),
                    lng: parseFloat(markerCfgsArray[0].coordinates[0])
                });
                $scope.map.fitBounds(singleBounds);
            });
        };

        function routeToPickup(deliver) {
            var driverCoords = new google.maps.LatLng(deliver.driver.currentLocation.coordinates[1], deliver.driver.currentLocation.coordinates[0]);
            var pickupCoords = new google.maps.LatLng(deliver.pickupLocation.coordinates[1], deliver.pickupLocation.coordinates[0]);
            return $scope.route(driverCoords, pickupCoords, deliver.transport);
        }

        function routeToDestination(deliver) {
            var driverCoords = new google.maps.LatLng(deliver.driver.currentLocation.coordinates[1], deliver.driver.currentLocation.coordinates[0]);
            var deliveryCoords = new google.maps.LatLng(deliver.deliveryLocation.coordinates[1], deliver.deliveryLocation.coordinates[0]);
            return $scope.route(driverCoords, deliveryCoords, deliver.transport);
        }

        function routeCompleted(deliver) {
            var pickupCoords = new google.maps.LatLng(deliver.pickupLocation.coordinates[1], deliver.pickupLocation.coordinates[0]);
            var deliveryCoords = new google.maps.LatLng(deliver.deliveryLocation.coordinates[1], deliver.deliveryLocation.coordinates[0]);
            return $scope.route(pickupCoords, deliveryCoords, deliver.transport);
        }

        $scope.route = function (origin, destination, transport) {
            var deferRoute = $q.defer();
            var request = {
                origin: origin,
                destination: destination,
                travelMode: (transport === 0) ? "BICYCLING" : "DRIVING" // 1, 2, 3
            };

            $scope.directionsService.route(request, function (result, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    $scope.directionsDisplay.setDirections(result);
                    $scope.directionsDisplay.setOptions({suppressMarkers: true});
                    $scope.directionsDisplay.setMap($scope.map);
                    deferRoute.resolve(result);
                } else {
                    deferRoute.reject();
                }
                $scope.isLoading = false;
                $rootScope.blur.dialogPushNotification = $rootScope.dialogPushNotification;
            });

            return deferRoute.promise;
        };

        // Call drawsignature function in pedidos
        $scope.loadSignatures = function (index) {
			$scope.deliveryMainInfoCont[index] = $scope.deliveryMainInfoCont[index] === 'closed' ? 'opened' : 'closed';
            drawSignatures();
        };

        /* Draw Signature Canvas */
        function drawSignatures() {
            console.log("destinations length: ", $scope.selectedDeliver.destinations.length);
            for (var p = 0; p < $scope.selectedDeliver.destinations.length; p++) {
                var currentDestination = $scope.selectedDeliver.destinations[p];
                if (currentDestination.status == 1) {
                    // if ($scope.ctx) {
                    //     $scope.ctx.clearRect(0, 0, $('#signature'+currentDestination._id).width(), $('#signature'+currentDestination._id).height());
                    // }
                    var signature = currentDestination.signature;
                    var cords = [];
                    var maxX = 0;
                    var maxY = 0;
                    var sign;
                    var i;
                    var j;
                    for (j = 0; j < signature.length; j++ ) {
                        sign = signature[j];
                        for (i = 0; i < sign.length; i++) {
                            maxX = Math.max(maxX, sign[i][0]);
                            maxY = Math.max(maxY, sign[i][1]);
                        }
                    }
                    var width = 100 / (maxX + 10);
                    var height = 150 / (maxY + 10);

                    if(currentDestination._id) {
                        $scope.ctx = document.getElementById('signature'+currentDestination._id).getContext('2d');
                        for (j = 0; j < signature.length; j++ ) {
                            sign = signature[j];
                            $scope.ctx.beginPath();
                            $scope.ctx.lineWidth = 3;
                            $scope.ctx.moveTo((5 + sign[0][0]) * width, (5 + sign[0][1]) * height);
                            for (i = 1; i < sign.length; i++) {
                                $scope.ctx.lineTo((5 + sign[i][0]) * width, (5 + sign[i][1]) * height);
                            }
                            $scope.ctx.stroke();
                        }
                    }
                }
            }
        }

        $scope.dropoffLocationFormattedAtIndex = function(destinationId) {
            for (var i = 0; i < $scope.selectedDeliver.destinations.length; i++) {
                if (destinationId == $scope.selectedDeliver.destinations[i]._id) {
                    if ($scope.selectedDeliver.destinations[i].dropoffLocation.comments === undefined || $scope.selectedDeliver.destinations[i].dropoffLocation.comments == ""){
                        return $scope.selectedDeliver.destinations[i].dropoffLocation.address;
                    }else{
                        return $scope.selectedDeliver.destinations[i].dropoffLocation.address + ", " + $scope.selectedDeliver.destinations[i].dropoffLocation.comments;
                    }
                }
            }
            return "";
        };


        $scope.pickupLocationFormatted = function(){
            if($scope.selectedDeliver && $scope.selectedDeliver.pickupLocation) {
                if ($scope.selectedDeliver.pickupLocation.comments === undefined || $scope.selectedDeliver.pickupLocation.comments == ""){
                    return $scope.selectedDeliver.pickupLocation.address;
                }else{
                    return $scope.selectedDeliver.pickupLocation.address + ", " + $scope.selectedDeliver.pickupLocation.comments;
                }
            } else return "";
        };

        $scope.dropoffDateFormattedAtIndex = function(destinationId) {
            for (var i = 0; i < $scope.selectedDeliver.destinations.length; i++) {
                if (destinationId == $scope.selectedDeliver.destinations[i]._id) {
                    if ($scope.selectedDeliver.destinations[i].dropoffDate === undefined || $scope.selectedDeliver.destinations[i].dropoffDate == ""){
                        return "--:--:--"
                    }else{
                        return $scope.selectedDeliver.destinations[i].dropoffDate.split("T")[0].replace("-");
                    }
                }
            }
            return "--:--:--";
        };

        $scope.getSignatureAtIndex = function(idx) {
            return $scope.selectedDeliver.destinations[idx].dropoffLocation;
        };
        /* Selection Dynamics */

        $scope.setSelected = function (id) {
            if ($scope.firstRate == id) {
                $scope.notClickedRatingBox = true;
            }
            if(!$scope.isDeliverSelected(id)) {
                resetMarkers();
                getDeliverDetail(id);
            }
        };

        $scope.isDeliverSelected = function (id) {
            return ($scope.selectedDeliver && $scope.selectedDeliver._id === id);
        };

        $scope.isStatusChanged = function (num) {
            return num !== 0;
        };

        /* Error Text */

        $scope.generateError = function (message) {
            $scope.formErrorText.push(message);
        };

        $scope.noPackage = function () {
            $rootScope.$emit('noPackage', {});
        };

        /* Redirect */

        $scope.redirect = function (url) {
            $location.path(url);
            $rootScope.$emit('redirection', {});
        };

        $scope.showDownloadLabelsDialog = function() {
            $scope.labelDate = new Date();
            $rootScope.blur.dialogDownloadLabels = $scope.dialogDownloadLabels = $scope.dialogDownloadLabelsForced = true;
        };


        /* Label download */
        $scope.downloadLabelsFromDeliveries = function() {
            var date = $scope.labelDate.getTime();
            DeliversService.downloadLabels(date).then(function (res) {
                var supportsDownloadAttribute = 'download' in document.createElement('a');
                var win;
                if(!supportsDownloadAttribute) {
                    win = $window.open('about:blank', "labels");
                }
                console.log("antes de window open");
                var data = res.data;
                console.log("DATA", data);
                var blob = new Blob([data], {type: "application/pdf"});
                console.log("BLOB", blob);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
                    console.log("downloadInvoice > IE case");
                    window.navigator.msSaveOrOpenBlob(blob, invoiceName);
                } else if (!supportsDownloadAttribute) { // Safari
                    console.log("downloadInvoice > Safari case");
                    win.location = $window.URL.createObjectURL(blob);
                } else { // Chrome, Firefox, Brave
                    console.log("downloadInvoice > other browsers case");
                    var anchor = angular.element('<a/>');
                    var oneAnchor = anchor.attr({
                        id: 'invoice-link-' + date,
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: "labels"
                    })[0];
                    document.body.appendChild(oneAnchor);
                    $timeout(function () {
                        oneAnchor.click();
                        document.body.removeChild(oneAnchor);
                    });
                }
            });
        }
    });

})();
